'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const PubSub = require('../PubSub'); 
const ViewShare = require('./share');
const template = require('../templates/sweeps.ejs');
const REGEX = require('../constants').REGEX;

module.exports = Backbone.View.extend({
    className: 'view-sweeps',
    events: { 
        'click .btn-close': 'closeModal',
        'click .mtv-close': 'routeMTVLink',
        'click .submit' : 'submitSweepstakes',
        'submit #vma-sweepstakes': 'submitSweepstakes',
        'click a': 'handleAnchorClick'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render', 'closeModal', 'submitSweepstakes');

        options = options || {};

        this.user = this.model.user;
        this.native = this.model.native;

        this.shareView = new ViewShare({
          model: options.shareModel,
          isThanks: true,
          shareUrl: options.shareUrl
        });
    },
    /**
     *
     */
    render: function () {

        var model = {
          copy: _.extend({}, this.model.copy, {
            redirect_url: this.model.thanks.redirect_url,
            close_text: this.model.thanks.close_text
          }),
          native: this.model.native
        };

        this.$el.html(template(model));
        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function() {
        if(this.native) {
            this.$el.addClass('native');
        }

        this.$el.find('.share').html(this.shareView.render().$el);
    },
    /**
     * 
     */
    inputValueChange: function(e) {

        var target = $(e.currentTarget);
        var val = target.val();
        var isEmail = target[0].id === 'email';

        // email validation
        if ( isEmail && !REGEX.EMAIL_VALIDATION.test( val )) {

            target.addClass('has-error');
            target.next('.error-message').show();

        // non-email validation
        } else if ( !isEmail && !REGEX.SWEEPS_INPUT.test( val )) {

            target.addClass('has-error');
            target.next('.error-message').show();

        // remove errors
        } else {

            target.removeClass('has-error');
            target.next('.error-message').hide();

        }

    },
    /**
     * 
     */
    checkboxChange: function(e) {
        var target = $(e.currentTarget);

        if(target[0].checked) {
            target.closest('.checkbox-parent').removeClass('has-error');
            target.siblings('.error-message.terms').hide();
        } else {
            target.closest('.checkbox-parent').addClass('has-error');
            target.siblings('.error-message.terms').show();
        }
    },
    /**
     * 
     */
    submitSweepstakes: function(e) {
        e.preventDefault();

        var params = {};
        var form = this.$('#vma-sweepstakes');

        this.isValid = true;

        _.each(form.serializeArray(), function(params, data) {
            params[data.name] = data.value;
            
            if(data.name == 'email') {

                if(!REGEX.EMAIL_VALIDATION.test(data.value)) {
                    this.isValid = false;
                    this.$el.find('.error-message.'+data.name+'').show();
                    this.$el.find('div.'+data.name+' input').addClass('has-error');
                } else {
                    this.$el.find('.error-message.'+data.name+'').hide();
                     this.$el.find('div.'+data.name+' input').removeClass('has-error');
                }
            
            } else {

                if(data.value == '') {
                    this.$el.find('div.'+data.name+' input').addClass('has-error');
                    this.$el.find('.error-message.'+data.name+'').show();
                    this.isValid = false;
                } else {
                    this.$el.find('div.'+data.name+' input').removeClass('has-error');
                    this.$el.find('.error-message.'+data.name+'').hide();
                }
            }

        }.bind(this, params));

        // if the form values are all valid, time to submit the form!
        if(this.isValid) {

            var omParams = { name: 'sweeps submit button', section: 'sweeps-modal', url: window.location.href };
            var gaParams = { eventCategory: 'Button Click', eventAction: 'Submit Sweepstakes' };

            PubSub.trigger('linkClick', omParams, gaParams);
            PubSub.trigger('submitSweepstakes', params);
        }
    },
    /**
     * [closeModal description]
     * @return {[type]} [description]
     */
    closeModal: function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     * 
     */
    routeMTVLink: function(e) {
        var href = e.currentTarget.href;
        var omParams = { name: 'link to mtv', section: 'sweeps-modal', destination: href };
        var gaParams = { eventCategory: 'Link Click', eventAction: 'Close Sweeps Modal to MTV' };

        PubSub.trigger( 'linkClick', omParams, gaParams);
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function() {
        this.user = null;
        return Backbone.View.prototype.remove.call(this);
    },
    /**
     * handleAnchorClick
     * @param {object} e - event object
     * @return {void}
     */
    handleAnchorClick: function( e ) {
        var val = e.target.innerText;
        var href = e.currentTarget.href;

        var omParams = { name: 'link: ' + val, section: 'sweeps-modal', destination: href };
        var gaParams = { eventCategory: 'Link Click', eventAction: 'Sweeps CTA: ' + val };

        PubSub.trigger( 'linkClick', omParams, gaParams);
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/sweeps.js